export default __webpack_public_path__ + "static/media/waka.2f0a6c70.svg";